import { inject, injectable } from "inversify";
import { SERVICES_TYPES } from "@/ioc/SERVICES_TYPES";
import { HttpClient } from "@/services/client";
import { ISubscriptionApi } from "./ISubscriptionApi";
import { OrganizationWallet } from "@/models/organization/OrganizationWallet";

@injectable()
export class SubscriptionApi implements ISubscriptionApi {
  @inject(SERVICES_TYPES.SUBSCRIPTION_HTTP_CLIENT)
  private client: HttpClient;

  private readonly baseUrl = "/wallets";

  async getOrganizationWallet(organizationId: string): Promise<OrganizationWallet> {
    const { data } = await this.client.get<OrganizationWallet>(
      `${this.baseUrl}/organization?organizationId=${organizationId}`
    );
    return data;
  }

  async adjustWalletBalance(organizationId: string, amount: number): Promise<void> {
    await this.client.post(`${this.baseUrl}/adjust`, { organizationId, amount });
  }
}
